import { COUNT_DEFAULT, DependencyFilterKeys, PAGE_DEFAULT } from '../../../shared/dependenciesV2';
import { DependencySource } from '../../../shared/vendoredDependencies';
import { empty } from '../asyncValue';

import type { DependenciesV2Store } from './types';

const initialState: Readonly<DependenciesV2Store> = Object.freeze({
  /**
   * The current project or release group scope
   */
  scope: null,
  /**
   * Indicates if a user is logged in and belong's to the target project's org.
   */
  isOrgMember: false,
  /**
   * Dependencies represents the dependencies currently being displayed in the table
   */
  dependencies: empty(),
  /**
   * Total dependencies represents the total number of dependencies in the project
   */
  totalDependencies: 0,
  /**
   * Filters
   */
  filters: {
    [DependencyFilterKeys.Title]: undefined,
    [DependencyFilterKeys.Status]: [],
    [DependencyFilterKeys.Depth]: [],
    [DependencyFilterKeys.LayerDepth]: [],
    [DependencyFilterKeys.HasIssues]: [],
    [DependencyFilterKeys.Licenses]: [],
    [DependencyFilterKeys.Fetchers]: [],
    [DependencyFilterKeys.ShowIgnored]: undefined,
    [DependencyFilterKeys.PackageLabels]: [],
    [DependencyFilterKeys.ExcludeAnyPackageLabel]: undefined,
    // By default we request only the Managed dependencies, irrespective of whether the Vendored Dependency Detection
    // feature flag is enabled or not as that is hard to determine in this context; we instead rely on the backend
    // VendoredFilter to skip (returning all results irrespective of source) when the feature flag is not enabled.
    [DependencyFilterKeys.Sources]: [DependencySource.Managed],
  },
  /**
   * Pagination
   */
  page: PAGE_DEFAULT,
  count: COUNT_DEFAULT,
  /**
   * The revision scan to show issues from (project scope only). The backend uses the latest scan when not set.
   */
  revisionScanId: undefined,
  /**
   * Licenses
   */
  licenses: empty(),
  /**
   * Package managers
   */
  packageManagers: empty(),
  /**
   * Root projects
   */
  rootProjects: empty(),
  /**
   * Resolve dependency
   */
  resolveDependency: empty(),
  /**
   * Build watch state
   * Holds state for watching GET /api/revisions for build data
   */
  buildWatch: {
    // Timeout loop for watching revisions
    interval: undefined,
    // Revisions to watch
    revisionsToWatch: [],
    // Response data
    revisions: empty(),
  },
  /**
   * Dependency manager version
   */
  depManagerVersion: undefined,
});

export default initialState;
